// extracted by mini-css-extract-plugin
module.exports = {"Container":"Product_Container__24age","Name":"Product_Name__rnzfn","Info":"Product_Info__IBbMc","Price":"Product_Price__AFn4q"};